import { redirect } from 'react-router-dom';

import { lazyWithRetry } from '@shared/factory';

import { useAuthStore } from '@/vendor/stores/authStore';
import { VendorRouteId, VendorRoutePath } from '@/types';

const { VENDOR_LOGIN_PAGE, VENDOR_DASHBOARD_PAGE, VENDOR_REDIRECT_PAGE } =
	VendorRouteId;
const { LOGIN, DASHBOARD, REDIRECT } = VendorRoutePath;

const VendorDashboard = lazyWithRetry(
	() =>
		import(
			/* webpackChunkName: 'VendorDashboard' */ '@/containers/splitSettlements/vendorDashboard/VendorDashboard.view.tsx'
		),
	'VendorDashboard',
);

const VendorLogin = lazyWithRetry(
	() =>
		import(
			/* webpackChunkName: 'VendorLogin' */ '@/containers/splitSettlements/vendorLogin/VendorLogin.view.tsx'
		),
	'VendorLogin',
);

const VendorRedirect = lazyWithRetry(
	() =>
		import(
			/* webpackChunkName: 'VendorRedirect' */ '@/components/vendor/redirectPage/RedirectPage.view.tsx'
		),
	'VendorRedirect',
);

export const vendorRoutes = [
	{
		path: LOGIN,
		id: VENDOR_LOGIN_PAGE,
		element: <VendorLogin />,
		loader: async ({ request }: { request: Request }) => {
			const url = new URL(request.url);
			const { metaId } = Object.fromEntries(url.searchParams);
			const storedId = await useAuthStore.getState().metaDetails?.metaId;
			const isAuthenticated = await useAuthStore.getState().isLoggedIn;

			if (metaId && storedId !== metaId) {
				await useAuthStore.getState().reset();
				return null;
			}

			if (isAuthenticated) {
				return redirect(DASHBOARD);
			}

			return null;
		},
	},
	{
		path: DASHBOARD,
		id: VENDOR_DASHBOARD_PAGE,
		element: <VendorDashboard />,
		loader: async () => {
			const isAuthenticated = await useAuthStore.getState().isLoggedIn;
			if (!isAuthenticated) {
				return redirect(LOGIN);
			}
			return null;
		},
	},
	{
		path: REDIRECT,
		id: VENDOR_REDIRECT_PAGE,
		element: <VendorRedirect />,
		loader: async () => {
			const isAuthenticated = await useAuthStore.getState().isLoggedIn;
			if (!isAuthenticated) {
				return redirect(LOGIN);
			}
			return null;
		},
	},
	{
		index: true,
		loader: async () => {
			const isAuthenticated = await useAuthStore.getState().isLoggedIn;
			if (isAuthenticated) {
				return redirect(DASHBOARD);
			}
			return redirect(LOGIN);
		},
	},
];
